export const TYPE_LIST = "TYPE_LIST";
export const ADD_CORPORATE_GATE = "ADD_CORPORATE_GATE";
export const ADD_APARTMENT_GATE = "ADD_APARTMENT_GATE";
export const LEAD_GATE = "LEAD_GATE";

